import React from "react";
import PropTypes from "prop-types";
import "./PromoCommentForm.scss";
import { useSelector } from "react-redux";
import PromoCodeField from "./PromoCodeField";

const PromoCommentForm = ({
  promoCode,
  comment,
  setPromoCode,
  setComment,
  isSubmitting,
  promoError,
  handleApplyPromoCode,
  isMobile,
  simplifiedVersion,
}) => {
  const submittedPromoCodes = useSelector(state => state.cart.submittedPromoCodes);


  return (
    <div className="promo-comment-container mt-8 gap-4 mb-4 relative">
      <PromoCodeField
        promoCode={promoCode}
        setPromoCode={setPromoCode}
        isSubmitting={isSubmitting}
        promoError={promoError}
        handleApplyPromoCode={handleApplyPromoCode}
        simplifiedVersion={true}
        submittedPromoCodes={submittedPromoCodes}
      />
      {!isMobile && !simplifiedVersion &&
        <div className="input-group relative">
          <div className="w-full flex flex-col gap-1">
            <label className="input-label">Special Instructions for Seller:</label>
            <div className="flex flex-row justify-between gap-5 items-center">
              <textarea
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Special Instructions"
                className="input-field"
              />
            </div>
          </div>
        </div>
      }
    </div>
  );
};

PromoCommentForm.propTypes = {
  promoCode: PropTypes.string,
  comment: PropTypes.string,
  setPromoCode: PropTypes.func.isRequired,
  setComment: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  promoError: PropTypes.string,
  handleApplyPromoCode: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  simplifiedVersion: PropTypes.bool
};

export default PromoCommentForm;
